import {FC} from "react";
import ReactMarkdown, {Options} from "react-markdown";

interface Props {
    markdown: string;
}


const options: Options = {
    skipHtml: true,
    unwrapDisallowed: true,
    allowedElements: ['p', 'br', 'strong', 'b', 'ol', 'ul', 'li'],
}

const Markdown: FC<Props> = ({markdown}) => {
    return <ReactMarkdown {...options}>
        {markdown}
    </ReactMarkdown>
}

export default Markdown